import { css } from "styled-components"

export const SectionWrapperStyles = css``
export const SliderWrapperStyles = css`
`
